// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasStatus_CarregaStatusSingleResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/despesas_status/carrega_status_single/<id>
 *
 * Returns a single expense status row.
 */
import type { DespesasStatus_StatusRow } from './DespesasStatus_StatusRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DespesasStatus_CarregaStatusSingleResponseDados = DespesasStatus_StatusRow;

export type DespesasStatus_CarregaStatusSingleResponse = ApiResponse<DespesasStatus_CarregaStatusSingleResponseDados>;

registerResponseContract('DespesasStatus_CarregaStatusSingleResponse', {
  _nullable:             { type: 'boolean', required: false },
  despesa_status_id:     { type: 'number',  required: true },
  despesa_status_titulo: { type: 'string',  required: true },
})
